/**
 * File: src/components/games-showcase.js
 * Mô tả: Component danh sách các tựa game được phát triển bởi SNT Games, hỗ trợ đa ngôn ngữ Anh / Việt.
 * Liên quan: src/i18n/i18n-service.js, src/components/game-card.js
 */

import { createElement } from '../utils/dom.js';
import { renderGameCard } from './game-card.js';
import { t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderGamesShowcase = (gamesList = []) => {
  const section = createElement('section', {
    className: 'section games-showcase-section',
    attributes: { id: 'games' },
  });

  const renderContent = () => {
    section.innerHTML = `
      <div class="container">
        <div class="section-header">
          <span class="section-badge">${t('showcase.badge')}</span>
          <h2 class="section-title">${t('showcase.title')}</h2>
          <p class="section-subtitle">${t('showcase.subtitle')}</p>
        </div>
        <div class="games-grid" id="games-grid-container"></div>
      </div>
    `;

    const gridContainer = section.querySelector('#games-grid-container');
    if (gridContainer && Array.isArray(gamesList)) {
      gamesList.forEach((game) => {
        gridContainer.appendChild(renderGameCard(game));
      });
    }
  };

  renderContent();
  onLanguageChange(() => renderContent());

  return section;
};
